/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateObjectionPositionV1Dto } from '../models/CreateObjectionPositionV1Dto';
import type { CreateObjectionV1Dto } from '../models/CreateObjectionV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { ObjectionPositionV1Dto } from '../models/ObjectionPositionV1Dto';
import type { ObjectionV1Dto } from '../models/ObjectionV1Dto';
import type { PatchObjectionPositionBulkV1Dto } from '../models/PatchObjectionPositionBulkV1Dto';
import type { PatchObjectionPositionV1Dto } from '../models/PatchObjectionPositionV1Dto';
import type { PatchObjectionV1Dto } from '../models/PatchObjectionV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ObjectionsService {
  /**
   * List all objections
   * @returns ObjectionV1Dto a entity list
   * @throws ApiError
   */
  public static objectionControllerV1FindAllV1(): CancelablePromise<Array<ObjectionV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/objections',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * Create a new objection
   * Creates an objection and optionally links multiple OperatingCostInvoiceLineItems (potentially from different invoices), each with its own comment and status.
   * @param requestBody
   * @returns ObjectionV1Dto create entity
   * @throws ApiError
   */
  public static objectionControllerV1CreateV1(
    requestBody: CreateObjectionV1Dto,
  ): CancelablePromise<ObjectionV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/objections',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * Delete many objections
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static objectionControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/objections',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * Get an objection by id
   * @param id UUID (v4) of the objection
   * @returns ObjectionV1Dto the entity
   * @throws ApiError
   */
  public static objectionControllerV1FindOneV1(id: string): CancelablePromise<ObjectionV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/objections/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * Patch Objection
   * @param id Objection ID (UUID v4)
   * @param requestBody
   * @returns ObjectionV1Dto the update entity
   * @throws ApiError
   */
  public static objectionControllerV1UpdatePartialV1(
    id: string,
    requestBody: PatchObjectionV1Dto,
  ): CancelablePromise<ObjectionV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/objections/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * Delete Objection
   * @param id Objection ID (UUID v4)
   * @returns ObjectionV1Dto the entity
   * @throws ApiError
   */
  public static objectionControllerV1RemoveOneV1(id: string): CancelablePromise<ObjectionV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/objections/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * List all positions for an objection
   * @param objectionId the objection uuid
   * @returns ObjectionPositionV1Dto a entity list
   * @throws ApiError
   */
  public static objectionPositionControllerV1FindAllV1(
    objectionId: string,
  ): CancelablePromise<Array<ObjectionPositionV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/objections/{objectionId}/positions',
      path: {
        objectionId: objectionId,
      },
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * Create a position for an objection
   * @param objectionId the objection uuid
   * @param requestBody
   * @returns ObjectionPositionV1Dto create entity
   * @throws ApiError
   */
  public static objectionPositionControllerV1CreateV1(
    objectionId: string,
    requestBody: CreateObjectionPositionV1Dto,
  ): CancelablePromise<ObjectionPositionV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/objections/{objectionId}/positions',
      path: {
        objectionId: objectionId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * Delete many operating cost objection position
   * @param objectionId the objection uuid
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static objectionPositionControllerV1RemoveManyV1(
    objectionId: string,
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/objections/{objectionId}/positions',
      path: {
        objectionId: objectionId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * get one positions for an objection
   * @param objectionId the objection uuid
   * @param id the position uuid
   * @returns ObjectionPositionV1Dto the entity
   * @throws ApiError
   */
  public static objectionPositionControllerV1FindOneV1(
    objectionId: string,
    id: string,
  ): CancelablePromise<ObjectionPositionV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/objections/{objectionId}/positions/{id}',
      path: {
        objectionId: objectionId,
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * Update a single position
   * @param objectionId Objection ID (UUID v4)
   * @param id Position ID (UUID v4)
   * @param requestBody
   * @returns ObjectionPositionV1Dto the update entity
   * @throws ApiError
   */
  public static objectionPositionControllerV1UpdatePartialV1(
    objectionId: string,
    id: string,
    requestBody: PatchObjectionPositionV1Dto,
  ): CancelablePromise<ObjectionPositionV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/objections/{objectionId}/positions/{id}',
      path: {
        objectionId: objectionId,
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * Delete a position (soft delete)
   * @param objectionId Objection ID (UUID v4)
   * @param id Position ID (UUID v4)
   * @returns ObjectionPositionV1Dto the entity
   * @throws ApiError
   */
  public static objectionPositionControllerV1RemoveOneV1(
    objectionId: string,
    id: string,
  ): CancelablePromise<ObjectionPositionV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/objections/{objectionId}/positions/{id}',
      path: {
        objectionId: objectionId,
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * Bulk update objection positions
   * @param objectionId the objection uuid
   * @param requestBody
   * @returns ObjectionPositionV1Dto the update entity
   * @throws ApiError
   */
  public static objectionPositionControllerV1UpdateManyPartialV1(
    objectionId: string,
    requestBody: PatchObjectionPositionBulkV1Dto,
  ): CancelablePromise<Array<ObjectionPositionV1Dto>> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/objections/{objectionId}/positions/bulk-update',
      path: {
        objectionId: objectionId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
}
